import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "redux/store";
import { ParentWrapper } from "styles/global";
import App from "App";
import Fonts from "styles/fonts/fonts";

// Seed CSS custom properties + body bg from the last-used theme BEFORE React
// renders, so the initial loading splash, OIDC redirect, and pre-auth pages
// don't briefly flash light when the user has dark themes saved. App.tsx
// keeps these in sync once the user's settings hydrate from the API.
try {
    const stored = localStorage.getItem("velocity:lastThemeColors");
    if (stored) {
        const themeColors = JSON.parse(stored);
        const root = document.documentElement;
        root.style.setProperty("--bg-color", themeColors.backgroundColor);
        root.style.setProperty("--bg-color-secondary", themeColors.backgroundColorSecondary);
        root.style.setProperty("--bg-color-tertiary", themeColors.backgroundColorTertiary);
        root.style.setProperty("--text-color", themeColors.textColor);
        root.style.setProperty("--text-color-secondary", themeColors.textColorSecondary);
        root.style.setProperty("--text-color-muted", themeColors.textColorMuted);
        root.style.setProperty("--border-color", themeColors.borderColor);
        root.style.setProperty("--border-color-secondary", themeColors.borderColorSecondary);
        root.style.setProperty("--primary-color", themeColors.primaryColor);
        root.style.setProperty("--primary-color-hover", themeColors.primaryColorHover);
        root.style.setProperty("--primary-color-light", themeColors.primaryColorLight);
        root.style.setProperty("--hover-bg", themeColors.hoverBackground);
        root.style.setProperty("--selected-bg", themeColors.selectedBackground);
        document.body.style.backgroundColor = themeColors.backgroundColor;
        document.body.style.color = themeColors.textColor;
    }
} catch {
    // localStorage can throw in private/incognito modes — ignore.
}

const rootEl = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
rootEl.render(
  <Provider store={store}>
    <ParentWrapper>
      <Fonts/>
      <App />
    </ParentWrapper>
  </Provider>
);